export default class TutorialMsgText extends Phaser.Group {
  constructor(x, y) {
    super(game);

    this.position.setTo(x, y);

    this.onTextAnimationFinished = new Phaser.Signal();
  }

  displayText(text) {
    if (text === undefined) return;

    if (this.textObj) {
      const oldTextObj = this.textObj;
      oldTextObj.dontAnimate = true;
      game.add.tween(oldTextObj)
        .to({ alpha: 0 }, 300, Phaser.Easing.Sinusoidal.Out, true)
        .onComplete.add(() => {
          oldTextObj.destroy();
        });
    }

    this.textObj = new G.Text(0, -3, OMT.language.getText(text), {
      style: 'font-purple',
      fontSize: G.OMTsettings.elements.tutorialMsg.fontSize,
      lineSpacing: G.OMTsettings.elements.tutorialMsg.lineSpacing,
    }, 0.5, 400, 190, true, 'center');
    this.add(this.textObj);

    // Disable typewriter effect for Hindi, Devanagari script doesn't work with it
    if (OMT.language.lang !== 'hi') {
      this.animateText(this.textObj);
    }
  }

  animateText(target) {
    const animationFinishSignal = this.onTextAnimationFinished;
    let animColorStopIndex = 0;

    function animate() {
      if (target.game === null || target.dontAnimate) {
        return;
      }

      // adding +1, because colors stops are changing
      // spaces between letters
      if (animColorStopIndex === target.text.length + 1) {
        animationFinishSignal.dispatch();
        return;
      }

      target.clearColors();
      target.addColor('rgba(0, 0, 0, 0)', animColorStopIndex);
      animColorStopIndex++;

      game.time.events.add(10, animate);
    }
    animate();
  }

  emptyText() {
    this.removeChild(this.textObj);
    this.textObj.destroy();
    this.textObj = null;
  }
}
